import styled from 'styled-components'

export const ContactForm = styled.form`
  padding: 0 10px 10px;
  text-align: ${({ theme }) => theme.rtl ? 'right' : 'left'};
  direction: ${({ theme }) => theme.rtl ? 'rtl' : 'ltr'};
`

export const ContactTextarea = styled.textarea`
  outline: none;
  width: 100%;
  min-height: 120px;
  resize: vertical;
  font-size: 14px;
  padding: 8px 10px;
  font-family: 'Cairo', sans-serif;
  border: 1px solid ${({ theme }) => theme.colors.gray};
  border-radius: 5px;
  box-sizing: border-box;

  ${({ theme, error }) => error && `
    border-color: ${theme.colors.error};
  `}
`

export const SubmitRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 8px;
`
